import { StepperFooter } from '../../navigation/stepper-footer/stepper-footer';
import { useValidatedStepper, type StepperValidationRule } from './useValidatedStepper';

type ValidatedStepperProps = {
  rules: ReadonlyArray<StepperValidationRule>;
};

export function ValidatedStepper({ rules }: ValidatedStepperProps) {
  const stepper = useValidatedStepper(rules);
  return <StepperFooter nextButtonEnabled={stepper.isNextEnabled} onNext={() => stepper.next()} />;
}
